export const DPR_BASE_API_PATH = "/progress-report";
export const DPR_LIST_COLUNMN_DEFS = [
  {
    headerName: "Id",
    field: "id",
    editable: false,
    headerCheckboxSelection: true,
    checkboxSelection: true,
    cellRenderer: "MaterialListCellButton",
    primarykeyfield: true,
    width: 150
  },
  // {
  //   headerName: "Project",
  //   field: "progress.project.name",
  //   editable: false,
  //   type: "text",
  //   width: 200
  // },
  
  
  // {
  //   headerName: "Location",
  //   field: "progress.location.name",
  //   editable: false,
  //   type: "text",
  //   width: 150
  // },
  // {
  //   headerName: "Stream",
  //   field: "progress.stream.name",
  //   editable: false,
  //   type: "text",
  //   width: 150
  // },

  {
    headerName: "Area",
    field: "progress.area",
    editable: false,
    type: "text",
    width: 150
  },
  {
    headerName: "Activity",
    field: "activity.name",
    editable: false,
    type: "text",
    width: 200
  },
  {
    headerName: "Contractor Name",
    field: "progress.contractor.name",
    editable: false,
    type: "text",
    width: 200
  },
  {
    headerName: "AMNS Incharge",
    field: "amns_supervisor",
    editable: false,
    type: "text",
    width: 200
  },
  {
    headerName: "Contractor Supervisor",
    field: "contractor_supervisor",
    editable: false,
    type: "text",
    width: 200
  },
  {
    headerName: "OIG Representative",
    field: "oig_representative",
    editable: false,
    type: "text",
    width: 200
  },
  // {
  //   headerName: "Sub Srea",
  //   field: "progress.sub_area",
  //   editable: false,
  //   type: "text",
  //   width: 200
  // },
  {
    headerName: "Unit",
    field: "measurement_unit.name",
    editable: false,
    type: "text",
    width: 150
  },
  {
    headerName: "Scope",
    field: "scope",
    editable: false,
    type: "integer",
    width: 150
  },
  {
    headerName: "Prev. Month Completion",
    field: "previous_month_completion",
    editable: false,
    type: "integer"
  },
  {
    headerName: "Monthly Plan",
    field: "monthly_plan",
    editable: false,
    type: "integer",
    width: 150
  },
  {
    headerName: "MTD Plan",
    field: "mtd_plan",
    editable: false,
    type: "integer",
    width: 150
  },
  {
    headerName: "Actuals",
    field: "actuals",
    editable: false,
    type: "integer",
    width: 150
  },
  {
    headerName: "Compliance %",
    field: "compliance",
    editable: false,
    type: "text",
    width: 150
  },
  {
    headerName: "Created by",
    field: "created_by",
    editable: false,
    type: "text",
    width: 200
  },
];

export const NOTIFICATION_MEESAGES = {
  WARNNIG_ALL_EXCEL_EXPORT: "Please wait! Exporting all data",
  WARNNIG_SELECTED_EXCEL_EXPORT: "Please wait! Exporting selected data",
  SUCCESS_EMAIL_EXCEL_EXPORT: "You will receive the exported data in your email shortly!",
  SUCCESS_EXCEL_EXPORT: "Successfully Exported to Excel",
  ERROR_EXCEL_EXPORT: "Error Exporting Data to Excel",
  ERROR_TEMPLATE_EXPORT: "Error downloading import template",
  SUCCESS_TEMPLATE_EXPORT: "Import template downloaded successfully"
};

export const DPR_APP = "daily_progress_report";
export const DPR_MODEL = "ProgressReport";
export const ACTIVITY_MODEL = "Activity";
